import { jwtExpired } from '../helper/jwt'
import socketIoClient from 'socket.io-client'
import { logger } from '../logger/logger'
import { resolveSocketEndpoint, LEGACY_SOCKET_ENDPOINT } from './endpoint'

const SESSION_REJECTED_STATUSES = [400, 401, 403]

export const connectSocketIo = async (token, setSocketCallback, authenticationCallback, socketReconnectedCallback, messageCallback, clientMonitor = false, deviceId, authUuid) => {
  const socketEndpoint = clientMonitor ? LEGACY_SOCKET_ENDPOINT : await resolveSocketEndpoint()
  const socket = socketIoClient(socketEndpoint.url, {
    path: socketEndpoint.path,
    port: 80,
    reconnection: true,
    forceNew: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
    query: {
      Authorization: clientMonitor ? `authUuid:${authUuid}` : `Bearer ${token}`,
      clientMonitor: clientMonitor,
      deviceId: deviceId ? deviceId : ''
    },
    auth: { token }, // todo: switch to auth token
    transports: ['websocket']
  })
  let firstConnection = true
  setSocketCallback(socket)
  socket.on('connect', () => {
    if (firstConnection) {
			logger.info('[socket-io] Socket connected')
    } else {
			logger.info('[socket-io] Socket reconnected')
      socketReconnectedCallback(socket)
    }
    firstConnection = false
  })
  socket.on('message', (data) => {
    messageCallback(data)
  })
  socket.on('connect_error', async (error) => {
		logger.info('[socket-io] Socket connect error')
    // todo: detect 401 error
    let jwt = socket.io.opts.query.Authorization?.substring(7)
    if (jwtExpired(jwt) && !clientMonitor) {
      let newToken
      try {
        newToken = await authenticationCallback()
      } catch (authenticationError) {
        if (!SESSION_REJECTED_STATUSES.includes(authenticationError?.response?.status)) {
          logger.warn('[socket-io] Socket re-authentication did not reject the session, keep reconnecting')

          return
        }
        logger.warn('[socket-io] Socket re-authentication rejected by the server, stopping reconnects')
        socket.disconnect()

        return
      }
			logger.info('[socket-io] Socket re-authentication success')
      socket.io.opts.query = {
        Authorization: `Bearer ${newToken}`
      }
      try {
        socket.disconnect()
      } catch (disconnectError) {
				logger.info('[socket-io] Socket disconnect caught: ' + disconnectError)
      }
      socket.connect()
    } else {
			logger.warn('[socket-io] Socket connection was broken ' + error)
    }
  })
  socket.on('disconnect', (reason, description) => {
		logger.info('[socket-io] Socket disconnected: ' + reason + ' ' + description)
    if (reason === 'io server disconnect') {
			logger.info('[socket-io] Try to reconnect after io server disconnect: ' + reason)
      socket.connect()
    }
  })
  socket.on('ping', () => {
    // logger.info('Socket ping')
  })
  socket.on('pong', () => {
    // logger.info('Socket pong')
  })
}
